import Empresa from "@/features/contabil/common/Empresa";
import {
  ReceitaFederalCertificadoResponse,
  ReceitaFederalStatusCadin,
  StatusSituacaoFiscalResponse
} from "@/features/contabil/services/dashboard/requests/types";

export const dialogCadinSituacaoFiscalProvider = Symbol(
  "dialogCadinSituacaoFiscalProvider"
);

export const receitaFederalProvider = Symbol("receitaFederal");
export const receitaFederalFilterProvider = Symbol("receitaFederalProvider");
export const empecilhosProvider = Symbol("empecilhos");

export enum ECadinFederalStatus {
  without,
  invalid,
  valid,
  pending
}

export enum ESituacaoFiscalStatus {
  without,
  invalid,
  valid,
  pending
}

export enum ESituacaoFiscalDeclaracoesStatus {
  valid,
  pending,
  error
}

export enum ESituacaoFiscalSuspensaStatus {
  valid,
  pending,
  error
}
export enum ECertificadoStatus {
  valid,
  pending,
  error,
  venceProximosDias,
  expirado
}

export enum ECertificadoAcessoContadorStatus {
  valid,
  pending,
  error
}

export interface ISituacaoFiscalFederalCadinTableData {
  status: ECadinFederalStatus;
  statusValue: ReceitaFederalStatusCadin | null;
  relatorio: string | null;
  consulta: string | null;
}

export interface ISituacaoFiscalFederalSituacaoFiscalTableData {
  status: ESituacaoFiscalStatus;
  statusValue: StatusSituacaoFiscalResponse | null;
  relatorio: string | null;
  consulta: string | null;
  debFiscal: string | null;
  debPrevidenciario: string | null;
  declaracoes: ESituacaoFiscalDeclaracoesStatus;
  suspensa: ESituacaoFiscalSuspensaStatus;
  ausenciaDeclaracao: boolean;
  exigibilidadeSuspensa: boolean;
}

export interface ISituacaoFiscalFederalCertificadoTableData {
  status: ECertificadoStatus;
  statusValue: ReceitaFederalCertificadoResponse;
  validade: string | null;
  // acessoContador: ECertificadoAcessoContadorStatus;
}

export interface ISituacaoFiscalTableData {
  empresa: Empresa;
  cadinFederal: ISituacaoFiscalFederalCadinTableData;
  situacaoFiscal: ISituacaoFiscalFederalSituacaoFiscalTableData;
  certificado: ISituacaoFiscalFederalCertificadoTableData;
  situacaoFiscalFile: string | null;
  cadinFile: string | null;
  id: string;
}

export interface IReceitaFederalFiltro {
  cadinStatus: string | undefined;
  cadinDataConsulta: [start: string, end: string] | undefined;
  cnpj: string[] | undefined;
  situacaoFiscalStatus: string | undefined;
  situacaoFiscalDataConsulta: [start: string, end: string] | undefined;
  declaracoes: string | undefined;
  suspensa: string | undefined;
}
